import React, { useContext, useEffect, useState } from "react";
import { Card, Label, ModalBody, Badge, Modal, ModalHeader } from "reactstrap";

import {
    Button,
    Block,
    BlockBetween,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Icon,
    Col,
    Row,
    OverlineTitle,
    Sidebar,
    UserAvatar,
} from "../../../components/Component";
import { useHistory } from "react-router";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { urlTenantID, currentTime, findUpper, formDataUsername, monthNames, todaysDate } from "../../../utils/Utils";
import { UserContext } from "../user-manage/UserContext";
import { notes } from "../user-manage/UserData";
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom'
import Api from "../../../Api";
import TenantTab from "./TenantTab";
import TenantHeading from "./TenantHeading";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";

const Secret = ({ match }) => {
    ///////////////////////////////////
    const [secretListState, setSecretList] = useState([]);

    const callGetTenantSecretByTenantID = async () => {
        const tenantSecretListData = await Api.GetTenantSecretByTenantID({ TenantId: urlTenantID() }); //match.params.id

        setSecretList(tenantSecretListData);
        //setTenantDetail({...tenantDetailState,[tenantId]: "1"});
    }
    useEffect(async () => {
        await callGetTenantSecretByTenantID();
    }, []);

    ////////////////////////////////////////
    const { contextData } = useContext(UserContext);
    const [data] = contextData;
    const location = useLocation()
    const [sideBar, setSidebar] = useState(false);
    const [user, setUser] = useState();
    const [noteData, setNoteData] = useState(notes);
    const [addNoteModal, setAddNoteModal] = useState(false);
    const [addNoteText, setAddNoteText] = useState("");
    const [edits, setEdits] = useState({});
    const history = useHistory();
    const [modal, setModal] = useState({
        add: false,
        edit: false,
    });

    const [val, setVal] = useState({
        applicationName: ""
    });
    const { errors, register, handleSubmit } = useForm();

    // grabs the id of the url and loads the corresponding data
    useEffect(() => {
        const id = match.params.id;
        if (id !== undefined || null || "") {
            let spUser = data.find((item) => item.id === Number(id));
            setUser(spUser);
        } else {
            setUser(data[0]);
        }
    }, [match.params.id, data]);

    // function to toggle sidebar
    const toggle = () => {
        setSidebar(!sideBar);
    };

    // delete a note
    const deleteNote = (id) => {
        let defaultNote = noteData;
        defaultNote = defaultNote.filter((item) => item.id !== id);
        setNoteData(defaultNote);
    };

    const submitNote = () => {
        let submitData = {
            id: Math.random(),
            text: addNoteText,
            date: `${monthNames[todaysDate.getMonth()]} ${todaysDate.getDate()}, ${todaysDate.getFullYear()}`,
            time: `${currentTime()}`,
            company: "Softnio",
        };
        setNoteData([...noteData, submitData]);
        setAddNoteModal(false);
        setAddNoteText("");
    };

    const handleAddSecret = async () => {

        let data = {
            "tenantId": urlTenantID(),
            "applicationName": val?.applicationName,
            "apiKey": "aa",
            "apiSecret": "bb",
            "createdBy": formDataUsername(),
        }

        try {
            let response = await Api?.InsertTenantSingleSecret(data);
            Swal?.fire({
                icon: response?.data?.statusCode === 200 ? "success" : "error",
                title: response?.data?.statusCode === 200 ? "Secret Added Succesfully" : "Something Went Wrong"
            });
            setModal({ ...modal, add: false, edit: false });
            setVal({ ...val, applicationName: "" });
            callGetTenantSecretByTenantID();
        } catch (error) {
            Swal?.fire({
                icon: "error",
                title: "Something Went Wrong"
            })
        }

    }

    const handleEditSecret = async (eve, item) => {
        setModal({ ...modal, add: false, edit: true });
        setVal({ ...val, applicationName: item?.applicationName });
        setEdits(item);
    }

    const EditSecret = async (eve) => {
        let data = {
            "tsid": edits?.tsid,
            "tenantId": urlTenantID(),
            "applicationName": val?.applicationName,
            "apiKey": "test",
            "apiSecret": "test",
            "updatedBy": formDataUsername()
        }

        try {
            let response = await Api?.UpdateSingleTenantSecret(data);
            Swal?.fire({
                icon: response?.data?.statusCode === 200 ? "success" : "error",
                title: response?.data?.statusCode === 200 ? "Secret Updatedd Succesfully" : "Something Went Wrong"
            });
            setModal({ ...modal, add: false, edit: false });
            setVal({ ...val, applicationName: "" });
            callGetTenantSecretByTenantID();
        } catch (error) {
            Swal?.fire({
                icon: "error",
                title: "Something Went Wrong"
            })
        }
    }

    const onFormCancel = () => {
        setModal({ ...modal, add: false, edit: false });
    }

    const handleChange = (eve) => {
        setVal({ ...val, applicationName: eve?.target?.value });
    }

    const deleteSecret = async (data) => {
        try {
            let response = await Api?.DeleteTenantSecret(data);
            Swal?.fire({
                icon: response?.data?.statusCode === 200 ? "success" : "error",
                title: response?.data?.statusCode === 200 ? "Secret Deleted Succesfully" : "Something Went Wrong"
            })
            callGetTenantSecretByTenantID();
        } catch (error) {
            Swal?.fire({
                icon: "error",
                title: "Something Went Wrong"
            })
        }
    }

    const handleDeleteSecret = async (eve, item) => {
        Swal?.fire({
            icon: "question",
            title: `Did You Want to Delete ${item?.applicationName} ?`,
            showDenyButton: true,
            denyButtonText: "cancel",
            denyButtonColor: "#6a3fcc",
            confirmButtonClass: "license_btn"
        }).then((result) => {
            if (result.isConfirmed) {
                let data = {
                    "tsid": item?.tsid,
                    "updateBy": "string",
                    "tenantId": urlTenantID()
                }
                deleteSecret(data);


            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire('Cancelled', 'Your operation was cancelled.', 'error');
            }
        });


    }


    return (
        <React.Fragment>
            <Head title="User Details - Regular"></Head>
            {user && (
                <Content>
                    <TenantHeading heading={"Add Tenant Detail"} />
                    <TenantTab match={match} />
                    <Block>
                        <Card className="card-bordered">
                            <div className="card-aside-wrap" id="user-detail-block">
                                <div className="card-content">

                                    <div className="card-inner">
                                        <Block>
                                            <div className="d-flex justify-content-between flex-wrap  mb-3">
                                                <h4 className="">Secret</h4>
                                                <div className="">
                                                    <Button color="primary"
                                                        onClick={() => { setModal({ add: true }); setVal({...val, applicationName: ""})}}
                                                    >
                                                        <Icon name="plus" />
                                                        <span>Add</span>
                                                    </Button>
                                                </div>
                                            </div>
                                            <table className="table">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th scope="col">Application Name</th>
                                                        <th scope="col">API Key</th>
                                                        <th scope="col">Secret Key</th>
                                                        <th scope="col">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {secretListState?.length > 0
                                                        ? secretListState?.map((item) => (
                                                            <tr key={item}>
                                                                <th scope="row">{item.applicationName}</th>
                                                                <td>{item.apiKey}</td>
                                                                <td>{item.apiSecret}</td>
                                                                <td className="d-flex">
                                                                    <Icon name="edit" className={"fs-3 me-3 text-primary cursor_pointer"}
                                                                        onClick={eve => handleEditSecret(eve, item)}
                                                                    ></Icon>
                                                                    <Icon name="delete" className={"fs-3 text-danger cursor_pointer"}
                                                                        onClick={eve => handleDeleteSecret(eve, item)}>
                                                                    </Icon>
                                                                </td>
                                                            </tr>
                                                        ))
                                                        : null}
                                                </tbody>
                                            </table>
                                        </Block>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </Block>
                    <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
                        <ModalHeader
                            close={
                                <button className="close" href="#close"
                                    onClick={(ev) => {
                                        ev.preventDefault();
                                        onFormCancel();
                                    }}>
                                    <Icon name="cross" />
                                </button>
                            }
                        >
                            Add Secret
                        </ModalHeader>
                        <ModalBody>
                            <form onSubmit={handleSubmit(eve => handleAddSecret(eve))} autoComplete="off">
                                <Row className="mb-3">
                                    <Col md="12">
                                        <div className="form-group">
                                            <label className="form-label">Application Name</label>
                                            <input
                                                onChange={handleChange}
                                                value={val.applicationName}
                                                className="form-control bg-blue-dim"
                                                type="text"
                                                name="applicationName"
                                                placeholder="Enter name"
                                                ref={register({ required: "This field is required" })}
                                            />
                                            {errors.applicationName && <span className="invalid">{errors.applicationName.message}</span>}
                                        </div>
                                    </Col>

                                </Row>

                                <div className="justify-end">
                                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                        <li>
                                            <Button color="primary" size="md" type="submit">
                                                Save
                                            </Button>
                                        </li>
                                        <li>
                                            <a
                                                href="#cancel"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                    onFormCancel();
                                                }}
                                                className="link link-light"
                                            >
                                                Cancel
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </form>
                        </ModalBody>
                    </Modal>

                    <Modal isOpen={modal?.edit} toggle={() => setModal({ edit: false })} className="modal-dialog-centered" size="lg">
                        <ModalHeader
                            close={
                                <button className="close" href="#close"
                                    onClick={(ev) => {
                                        ev.preventDefault();
                                        onFormCancel();
                                    }}>
                                    <Icon name="cross" />
                                </button>
                            }
                        >
                            Edit License
                        </ModalHeader>
                        <ModalBody>
                            <form onSubmit={handleSubmit(eve => EditSecret(eve))} autoComplete="off">
                                <Row className="mb-3">
                                    <Col md="12">
                                        <div className="form-group">
                                            <label className="form-label">Application Name</label>
                                            <input
                                                onChange={handleChange}
                                                value={val.applicationName}
                                                className="form-control bg-blue-dim"
                                                type="text"
                                                name="applicationName"
                                                placeholder="Enter name"
                                                ref={register({ required: "This field is required" })}
                                            />
                                            {val.applicationName === "" && <span className="invalid">This field is required</span>}
                                        </div>
                                    </Col>

                                </Row>

                                <div className="justify-end">
                                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                        <li>
                                            <Button color="primary" size="md" type="submit">
                                                Save
                                            </Button>
                                        </li>
                                        <li>
                                            <a
                                                href="#cancel"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                    onFormCancel();
                                                }}
                                                className="link link-light"
                                            >
                                                Cancel
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </form>
                        </ModalBody>
                    </Modal>
                </Content>
            )}
        </React.Fragment>
    );
};
export default Secret;
